import { gql } from "@apollo/client";

export const GET_TRANSACTIONS = gql`
  query Reports(
    $where: WalletInput!
    $limit: Int
    $skip: Int
    $orderBy: CreditSortInput
  ) {
    getAllTransactions(
      where: $where
      limit: $limit
      skip: $skip
      orderBy: $orderBy
    ) {
      reports {
        credited
        receivedMoney
        totalPaidCompleted
        chartDatas {
          _id
          amount
          description
          tag1
          tag2
          tag3
          paymentTime
          transactionId
          origin
          qrString
          appLink
          createdAt
          updatedAt
          status
          bill
          billStatus
          isClaim
          remark
          isMerchantIdPayment
          isAffialiatePayment
          status
        }
      }
      data {
        _id
        amount
        description
        tag1
        tag2
        tag3
        paymentTime
        transactionId
        origin
        qrString
        appLink
        createdAt
        updatedAt
        status
        bill
        billStatus
        remark
        isMerchantIdPayment
        isAffialiatePayment
      }
      total
    }
  }
`;

//* [MULTI-SHOP] ເງິນຂອງຮ້ານທີ່ຄ້າງຢູ່ບັນຊີກາງ 4B (ບິນທີ່ລູກຄ້າຊື້ຫຼາຍຮ້ານໃນບິນດຽວ)
//* ຮ້ານເຄມເອງບໍ່ໄດ້ ຕ້ອງລໍແອດມິນໂອນໃຫ້ — ໂຕເລກມາຈາກ orderGroup ບໍ່ແມ່ນຈາກ phapay
export const GET_SHOP_CENTRAL_BALANCE = gql`
  query ShopCentralBalance($where: WalletInput) {
    getShopCentralBalance(where: $where) {
      status
      msg
      pending
      pendingCount
      settled
      settledCount
    }
  }
`;

export const GET_INVOICE_CREDITS = gql`
  query BillData(
    $limit: Int
    $skip: Int
    $orderBy: CreditSortInput
    $where: WalletInput!
  ) {
    getInvoicesCredits(
      limit: $limit
      skip: $skip
      orderBy: $orderBy
      where: $where
    ) {
      billData {
        id
        status
        billNo
        price
        amount
        totalPrice
        createdAt
        updatedAt
        approvedBy
        code
        paymentData
        shop
        shopName
        paySlip
        note
        currency
      }
      total
    }
  }
`;
